import React from 'react'
import { ViewStyle } from 'react-native'
import Animated, {
  AnimatedStyle,
  useAnimatedStyle,
  useSharedValue,
} from 'react-native-reanimated'
import cn from '@ui/utils/cn'

type Props = {
  style: AnimatedStyle<ViewStyle>
  styleOuter?: AnimatedStyle<ViewStyle>
  children: React.ReactNode
  className?: string
}

export default function AnimatedEmpty({
  style,
  styleOuter,
  children,
  className,
}: Props) {
  const height = useSharedValue(0)

  const containerStyle = useAnimatedStyle(() => ({
    height: height.value,
  }))

  return (
    <Animated.View style={[containerStyle, styleOuter]}>
      <Animated.View
        className={cn('absolute left-0 top-0 w-full p-8', className)}
        style={style}
        onLayout={(e) => {
          height.set(e.nativeEvent.layout.height)
        }}
      >
        {children}
      </Animated.View>
    </Animated.View>
  )
}
